import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e5e7eb;
  padding: 1.5rem 2rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
`;
const Price = styled.span`
  font-size: 2rem;
  font-weight: 700;
  color: #232d4d;
`;
const EditInput = styled.input`
  font-size: 1.3rem;
  font-weight: 600;
  width: 120px;
  padding: 0.4rem 0.7rem;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  margin-right: 1rem;
`;
const SaveBtn = styled.button`
  background: #232d4d;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 0.5rem 1.3rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
`;

export default function BedPriceCard({ onPriceChange }) {
  const [price, setPrice] = useState(() => {
    const stored = localStorage.getItem('bedPrice');
    return stored ? Number(stored) : 699;
  });
  const [edit, setEdit] = useState(false);
  const [input, setInput] = useState(price);
  useEffect(() => { setInput(price); }, [price]);
  function handleSave() {
    setPrice(input);
    localStorage.setItem('bedPrice', input);
    setEdit(false);
    if (onPriceChange) onPriceChange(input);
  }
  return (
    <Card>
      <div style={{flex:1}}>
        <div style={{fontWeight:600, fontSize:'1.1rem', color:'#6b7280'}}>Package-Based Pricing</div>
        {edit ? (
          <>
            <div style={{color:'#6b7280', fontSize:'0.9rem', marginTop:'8px'}}>Pricing is now dynamic based on selected packages</div>
            <SaveBtn onClick={handleSave}>Save</SaveBtn>
            <SaveBtn style={{background:'#eee',color:'#232d4d',marginLeft:8}} onClick={()=>{setEdit(false);setInput(price);}}>Cancel</SaveBtn>
          </>
        ) : (
          <>
            <div style={{color:'#6b7280', fontSize:'0.9rem', marginTop:'8px'}}>
              • Hourly: ₹199-₹499<br/>
              • Regular: ₹599<br/>
              • Weekly: ₹3,499<br/>
              • Monthly: ₹11,999
            </div>
          </>
        )}
      </div>
      <div style={{fontSize:'1.05rem', color:'#888'}}>This price will be shown to users on the homepage.</div>
    </Card>
  );
}
